<template>
  <div class="price-item">
    <div class="vip_tag" v-if="data.priceHeaderRank === 2">
      <img :src="ossPath + '/pages/queryPrice/vip_price_3.png'" alt="">
    </div>
    <div class="line-info">
      <div class="line-logo" v-if="isOpen" :class="{ blur: isCarrierNameBlurring }">
        <img :src="data.carrierLogoUrl || defaultIcon" alt="">
      </div>
      <div class="line-name" :class="{ blur: isCarrierNameBlurring }">{{ data.carrierAbbr }}</div>
    </div>
    <div class="product-info aging">
      <div class="product-info-detail">{{ data.agingIsShow ? data.aging : data.extractionAging }}</div>
      <div class="product-info-label">参考时效</div>
    </div>
    <div class="product-info product-type">
      <el-tooltip placement="top" :content="data.goodsTypeNames">
        <div class="product-info-detail">{{ data.goodsTypeNames }}</div>
      </el-tooltip>
      <div class="product-info-label">可接货物</div>
    </div>
    <div class="product-info contain-tax">
      <div class="product-info-detail">{{ data.containsTheTariffs ? '包税' : '不包税' }}</div>
      <div class="product-info-label">是否包税</div>
    </div>
    <div class="price">
      <price-blurring
        :price-display-type="data.priceDisplayType"
        :currency="data.currency"
        :price="data.subsidyPrice ? data.subsidyPrice : data.priceinfo"
        inline
        class="product-price"
      >
        <div class="price-info">
          <span style="margin-right: 5px;" v-if="data.price !== '单询'">{{ data.currency }}</span>
          <span v-if="isBlurring">****</span>
          <span style="font-size: 24px;font-weight: 600" v-else>{{ data.price }}</span>
          <span v-if="data.price !== '单询'">/{{ data.unit }}</span>
        </div>
      </price-blurring>
    </div>
    <el-button type="primary" class="order-btn" @click="toOrder">联系我们</el-button>
  </div>
</template>
<script>
import { ossPath } from '../../../../../../devParams'
import { mapState, mapGetters } from "vuex";
import priceBlurring from "../../../../../../common/priceBlurring/index.vue";

export default {
  components: { priceBlurring },
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      defaultIcon:ossPath + "/pages/home/hot_country_default_icon.png",

    }
  },
  computed: {
    ...mapState(['isOpen','Authorization']),
    ...mapGetters(["realNameState","token","realNameType","isInquiryUserSuccess"]),
    isBlurring(){
      if(this.data.priceDisplayType === 2) return false;
      if(!this.token) return true;
      if(this.Authorization.temporaryAuthentication) return false;
      if(this.isInquiryUserSuccess) return false;
      if(this.realNameType === 1 && this.realNameState === 1) return false;
      if(this.realNameType === 6 && this.realNameState === 1) return false;
      return this.realNameState !== 3;
    },
    isCarrierNameBlurring() {
      if(!this.token) return true;
      if(this.Authorization.temporaryAuthentication) return false;
      if(this.isInquiryUserSuccess) return false
      if(this.realNameType === 1 && this.realNameState === 1) return false;
      // if (this.realNameType === 7) return true
      return this.realNameState !== 3;
    },
  },
  methods: {
    toOrder() {
      this.$emit('toOrder', this.data)
    }
  }
}
</script>
<style lang="scss" scoped>
div, span {
  user-select: none;
}
.price-item {
  width: 1200px;
  height: 80px;
  margin-bottom: 10px;
  background: #FFFFFF;
  border-radius: 12px;
  box-sizing: border-box;
  transition: .3s ease;
  position: relative;
  display: flex;
  align-items: center;
  border: 1px solid #FFFFFF;
  &:hover {
    background: #FCF4F1;
    box-shadow: 0 2px 10px 0 rgba(0,0,0,0.2);
    border: 1px solid #FF4D01;
  }
}
.line-info {
  margin-left: 20px;
  display: flex;
  align-items: center;
  position: absolute;
  left: 0;
  .line-logo {
    width: 50px;
    height: 50px;
    margin-right: 10px;
    border-radius: 50%;
    overflow: hidden;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .line-name {
    width: 140px;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #141414;
    line-height: 28px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
.product-info {
  position: absolute;
  &-detail {
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #141414;
    line-height: 22px;
  }
  &-label {
    margin-top: 2px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: #999999;
    line-height: 20px;
  }
}
.aging {
  left: 231px;
}
.product-type {
  left: 428px;
}
.contain-tax {
  left: 600px;
}
.price {
  position: absolute;
  left: 797px;
}
.price-info {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  color: #FF4D01;
  line-height: 22px;
}
.order-btn {
  width: 115px;
  height: 50px;
  border-radius: 4px;
  position: absolute;
  right: 19px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #FFFFFF;
}
.blur {
  filter: blur(6px);
}
.vip_tag {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/components/homeHotPriceCompare/components/priceItem.vue